module.exports = __webpack_public_path__ + "static/media/VectorUpArrow.2383d706.svg";